import React, { useEffect, useState } from "react";
import styles from './ProgressBar.module.css';
import classNames from "classnames/bind";
import CameraIcon from "../../assets/images/logo-1.png";
import { Close } from "../Icons/Icons";

const cx = classNames.bind(styles)

function ProgressBar({ data, onClose, handleCancel }) {
    console.log('data', data);

    return (
        <div className={cx("progressBar")}>
            <div className={cx('header')}>
                <p className={cx('title')}>Đang tải</p>
                <span onClick={onClose}>
                    <Close />
                </span>
            </div>
            <div className={cx('content')}>
                {data?.map(video => {
                    return (
                        <div className={cx('item-download')} key={video?.camera_code}>
                            <div className={cx('info')}>
                                <img src={CameraIcon} alt="camera" style={{ height: 16 }} />
                                <p className={cx('file-name')}>{video?.name}</p>
                            </div>
                            <div className={cx('action')}>
                                <div className={cx("progress")}>
                                    <div className={cx("content-progress")} style={{ width: `${video?.progress}%` }}></div>
                                </div>
                            </div>
                            {video?.completed && (
                                <div className={cx('cancel')}>
                                    <button onClick={handleCancel} className={cx('button-cancel')}>Hủy</button>
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ProgressBar;